import { render, staticRenderFns } from "./Ocorrencia.vue?vue&type=template&id=1ee50f60"
import script from "./Ocorrencia.vue?vue&type=script&lang=js"
export * from "./Ocorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports